export default {
  deleteTitle: 'Student',
  overviewTitle: 'Students',
  overviewRouterUrl: 'students',
  getFilterName (context) { return 'students' },
  overviewApiUrl: '/students/',
  detailTitle: 'Student Detail',
  detailRouterUrl: 'student',
  detailApiUrl: '/students/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  advancedSearch: true,
  sortOrder: [
    {
      field: 'last_name',
      sortField: 'last_name',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'First Name', name: 'first_name', sortField: 'first_name', link: '#/student/{id}'},
    {title: 'Last Name', name: 'last_name', sortField: 'last_name', link: '#/student/{id}'},
    {title: 'Citizenship 1', name: 'citizenship1_cntry', sortField: 'nationality_cntry'},
    {title: 'Street Address', name: 'address', sortField: 'address'},
    {title: 'Postal Code', name: 'zip', sortField: 'zip'},
    {title: 'City', name: 'city', sortField: 'city'},
    {title: 'Country', name: 'cntry', sortField: 'cntry'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/Student/FieldDefs.js